// extracted by mini-css-extract-plugin
export default {"containerSlider":"Home_containerSlider__+k+HN","hideButton":"Home_hideButton__VPKoH","homeFlexCardContainer":"Home_homeFlexCardContainer__-uTVi","hr":"Home_hr__dNAB9"};